export default __webpack_public_path__ + "5d1b8e1.png";